export default __webpack_public_path__ + "static/media/headerStamp.6d4690f4.svg";